<app-nav></app-nav>

<main class="contact-page">
  <!-- ─── Hero ─────────────────────────────────────────────────────── -->
  <section class="contact-hero brand-section">
    <div class="hero-orb hero-orb-blue"></div>
    <div class="hero-orb hero-orb-green"></div>

    <div class="contact-hero-inner">
      <span class="brand-eyebrow">Get in touch</span>
      <h1>Tell us what's on your mind.</h1>
      <p class="brand-lede">
        Bug reports, partnership questions, app feedback, or just a hello —
        we read every message and respond from a real inbox.
      </p>
    </div>
  </section>

  <!-- ─── Form + ways to reach us ──────────────────────────────────── -->
  <section class="contact-body brand-section">
    <div class="contact-grid">
      <!-- Form card -->
      <div class="contact-form-card">
        <div class="form-card-header">
          <span class="brand-eyebrow">Send a message</span>
          <h2>We typically reply within 1–2 business days.</h2>
        </div>

        <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="contact-form">
          <div class="form-row">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Your name</mat-label>
              <input matInput formControlName="name" placeholder="Jane Doe">
              @if (contactForm.get('name')?.invalid && contactForm.get('name')?.touched) {
                <mat-error>{{ getErrorMessage('name') }}</mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Email address</mat-label>
              <input matInput type="email" formControlName="email" placeholder="jane@example.com">
              @if (contactForm.get('email')?.invalid && contactForm.get('email')?.touched) {
                <mat-error>{{ getErrorMessage('email') }}</mat-error>
              }
            </mat-form-field>
          </div>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Company (optional)</mat-label>
            <input matInput formControlName="company" placeholder="Where you work">
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Subject</mat-label>
            <input matInput formControlName="subject" placeholder="What is this about?">
            @if (contactForm.get('subject')?.invalid && contactForm.get('subject')?.touched) {
              <mat-error>{{ getErrorMessage('subject') }}</mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Message</mat-label>
            <textarea matInput formControlName="message" rows="6"
              placeholder="The more detail the better — especially for bug reports."></textarea>
            @if (contactForm.get('message')?.invalid && contactForm.get('message')?.touched) {
              <mat-error>{{ getErrorMessage('message') }}</mat-error>
            }
          </mat-form-field>

          <!--
            Captcha + submit row. Side-by-side on desktop so the button
            shares a vertical baseline with the Cloudflare widget; stacks
            on phones where there is not horizontal room for both.
          -->
          <div class="form-submit-row">
            <div id="turnstile-widget" class="turnstile-widget"></div>
            <button
              type="submit"
              class="brand-btn brand-btn-primary brand-btn-large submit-button"
              [disabled]="isSubmitting"
            >
              @if (isSubmitting) {
                <mat-icon class="spinning">sync</mat-icon>
                Sending...
              } @else {
                <mat-icon>send</mat-icon>
                Send message
              }
            </button>
          </div>

          @if (submitSuccess) {
            <div class="form-banner banner-success">
              <mat-icon>check_circle</mat-icon>
              <span>Got it — thanks for reaching out. We'll respond within 1–2 business days.</span>
            </div>
          }
          @if (submitError) {
            <div class="form-banner banner-error">
              <mat-icon>error_outline</mat-icon>
              <span>
                Something went wrong on our side. Try again, or email us directly at
                <a href="mailto:contact@stml.app">contact&#64;stml.app</a>.
              </span>
            </div>
          }
        </form>
      </div>

      <!-- Ways-to-reach-us aside -->
      <aside class="contact-aside">
        <div class="aside-block">
          <span class="brand-eyebrow">Other ways to reach us</span>
          <h3>Pick whatever works.</h3>
        </div>

        <div class="contact-methods" role="list">
          @for (method of contactMethods; track method.title) {
            <div class="contact-method" role="listitem">
              <div class="contact-method-icon">
                <mat-icon>{{ method.icon }}</mat-icon>
              </div>
              <div class="contact-method-copy">
                <span class="contact-method-title">{{ method.title }}</span>
                @if (method.link) {
                  <a [href]="method.link" class="contact-method-value">{{ method.value }}</a>
                } @else {
                  <span class="contact-method-value">{{ method.value }}</span>
                }
              </div>
            </div>
          }
        </div>

        <div class="aside-tip">
          <mat-icon>lightbulb_outline</mat-icon>
          <p>
            For bug reports, please tell us what device you're on and what you
            were doing when it happened. It helps us reproduce the issue
            quickly.
          </p>
        </div>
      </aside>
    </div>
  </section>
</main>

<app-footer></app-footer>
